import { Component, OnInit } from '@angular/core';
import { PayService } from '../service/pay.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-mes-mensualite',
  templateUrl: './mes-mensualite.component.html',
  styleUrls: ['./mes-mensualite.component.css'],
  standalone: false
})
export class MesMensualiteComponent implements OnInit {
  mensuelist: any[] = [];
  allMensualites: any[] = [];
  monthOptions: { value: string; label: string }[] = [];
  selectedMonth: string;
  sigle: string;

  constructor(private userService: PayService, private router: Router) { }

  ngOnInit(): void {
    this.sigle = localStorage.getItem('sigle');
    this.getutilisateurmenssualite();
  }

  getutilisateurmenssualite() {
    this.userService.getUtilisateurMensualites().subscribe((data: any[]) => {
      this.allMensualites = data || [];
      this.buildMonthOptions();
      this.applyMonthFilter(this.selectedMonth);

    })
  }

  applyMonthFilter(monthKey: string) {
    this.selectedMonth = monthKey || this.getCurrentMonthKey();
    this.mensuelist = this.allMensualites.filter(m => this.getMonthKeyFromParts(m?.annee, m?.month) === this.selectedMonth);
  }

  private buildMonthOptions() {
    const months = new Set<string>();
    const current = this.getCurrentMonthKey();
    months.add(current);
    this.allMensualites.forEach(m => {
      const key = this.getMonthKeyFromParts(m?.annee, m?.month);
      if (key) { months.add(key); }
    });
    this.monthOptions = Array.from(months)
      .sort((a, b) => b.localeCompare(a))
      .map(key => ({ value: key, label: this.formatMonthLabel(key) }));
    this.selectedMonth = current;
  }

  private getMonthKeyFromParts(year: any, month: any): string {
    if (year == null || month == null) { return ''; }
    const m = Number(month);
    const y = Number(year);
    if (isNaN(m) || isNaN(y)) { return ''; }
    const paddedMonth = String(m).padStart(2, '0');
    return `${y}-${paddedMonth}`;
  }

  private getCurrentMonthKey(): string {
    const now = new Date();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    return `${now.getFullYear()}-${month}`;
  }

  private formatMonthLabel(key: string): string {
    const [year, month] = key.split('-').map(Number);
    const d = new Date(year, (month || 1) - 1);
    return d.toLocaleString('fr-FR', { month: 'long', year: 'numeric' });
  }

}
